module.exports = __webpack_public_path__ + "media/newstyle/images/book-1-translation-9f5ce7ff889a06b8c1ac8bff7093d14d.png";